'use client';

import { ReportContext } from '@/app/providers/reportProvider';
import { Link } from '@/i18n/routing';
import { useTranslations } from 'next-intl';
import { useContext } from 'react';
import { FaHome } from 'react-icons/fa';
import { HiChevronRight } from 'react-icons/hi2';

export default function BredCrum() {
  const report = useContext(ReportContext);
  const regionalText = useTranslations('breadcrum');
  return (
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb mb-0 flex lg:flex-row gap-x-2 items-center flex-wrap">
        <li>
          <Link href="/" className="my-2 lg:my-0">
            <FaHome aria-label="Home" />
          </Link>
        </li>
        <li>
          <HiChevronRight />
        </li>
        <li aria-current="page">
          <Link className="text-head my-2 lg:my-0" href="/latest-insights">
            {regionalText('industry_reports')}
          </Link>
        </li>
        <li>
          <HiChevronRight />
        </li>
        <li aria-current="page">
          <Link className="text-head my-2 lg:my-0" href="/industries">
            {regionalText('industries')}
          </Link>
        </li>
        <li>
          <HiChevronRight />
        </li>
        <li aria-current="page">
          <Link
            className="text-head my-2 lg:my-0"
            href={`/industries/${report.catCustomName}`}
          >
            {report.catName}
          </Link>
        </li>
        <li>
          <HiChevronRight />
        </li>
        <li aria-current="page" className="capitalize">
          {report.keyword}
        </li>
      </ol>
    </nav>
  );
}
